export const BEST_OF_MAX_EVENT_REFRESH_INTERVAL_MS = 60_000;
export const BEST_OF_MIN_EVENT_REFRESH_INTERVAL_MS = 1_000;

export const getBestOfEventRefreshInterval = (
  nextTransitionAt?: string | null,
  now: number = Date.now()
): number | false => {
  if (!nextTransitionAt) return false;

  const transitionAt = Date.parse(nextTransitionAt);
  if (Number.isNaN(transitionAt)) return false;

  return Math.min(
    Math.max(
      transitionAt - now + BEST_OF_MIN_EVENT_REFRESH_INTERVAL_MS,
      BEST_OF_MIN_EVENT_REFRESH_INTERVAL_MS
    ),
    BEST_OF_MAX_EVENT_REFRESH_INTERVAL_MS
  );
};
